module.exports = __webpack_public_path__ + "media/images/client-14-7601ba2c43a7c0f9a2be518426d7ff4f.png";